/**
 * @typedef {{
 *   id: string,
 *   name: string,
 *   displayName: string,
 *   lakehouseName?: string,
 *   lakehouseSQLEndpoint?: string,
 *   createdAt?: string,
 *   updatedAt?: string,
 * }} NormalizedChatbotAgent
 */

const LAKEHOUSE_NAME_KEYS = [
  'lakehouseName',
  'lakehouse_name',
  'lakeHouseName',
  'fabricLakehouseName',
  'fabric_lakehouse_name',
  'warehouseName',
  'sqlWarehouseName',
];

const LAKEHOUSE_SQL_KEYS = [
  'lakehouseSQLEndpoint',
  'lakehouse_sql_endpoint',
  'lakehouseSqlEndpoint',
  'sqlEndpoint',
  'sql_endpoint',
  'fabricSqlEndpoint',
  'datawarehouseEndpoint',
  'dataWarehouseEndpoint',
];

function firstNonEmptyString(row, keys) {
  if (!row || typeof row !== 'object') {
    return '';
  }
  for (const k of keys) {
    const v = row[k];
    if (v != null && String(v).trim() !== '') {
      return String(v).trim();
    }
  }
  return '';
}

function pickLakehouseName(row) {
  return firstNonEmptyString(row, LAKEHOUSE_NAME_KEYS);
}

function pickLakehouseSqlEndpoint(row) {
  return firstNonEmptyString(row, LAKEHOUSE_SQL_KEYS);
}

/**
 * Lakehouse fields from an agent row, config object, or nested payload.
 *
 * @param {object | null | undefined} source
 * @returns {{ lakehouseName: string, lakehouseSQLEndpoint: string }}
 */
export function extractLakehouseFields(source) {
  if (!source || typeof source !== 'object') {
    return { lakehouseName: '', lakehouseSQLEndpoint: '' };
  }
  return {
    lakehouseName: pickLakehouseName(source),
    lakehouseSQLEndpoint: pickLakehouseSqlEndpoint(source),
  };
}

/**
 * @param {object} row
 * @returns {NormalizedChatbotAgent | null}
 */
export function normalizeChatbotAgentRow(row) {
  if (
    !row ||
    typeof row.id !== 'string' ||
    row.id.trim() === '' ||
    typeof row.name !== 'string'
  ) {
    return null;
  }
  const id = row.id.trim();
  const displayName =
    row.displayName != null && String(row.displayName).trim() !== ''
      ? String(row.displayName)
      : row.name;
  return {
    id,
    name: row.name,
    displayName,
    lakehouseName: pickLakehouseName(row),
    lakehouseSQLEndpoint: pickLakehouseSqlEndpoint(row),
    createdAt: row.createdAt,
    updatedAt: row.updatedAt,
  };
}
